import { IconMapPin } from '../Icons';
import { useState } from 'react';

interface ShippingSettingsData {
  pickupLocation?: string;
  pickupLocationUrl?: string;
  pickupNote?: string;
}

interface Props {
  settings: ShippingSettingsData;
  onChange: (settings: ShippingSettingsData) => void;
}

export default function ShippingSettings({ settings, onChange }: Props) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">取件地點</label>
        <input
          type="text"
          value={settings.pickupLocation || ''}
          onChange={(e) => onChange({ ...settings, pickupLocation: e.target.value })}
          placeholder="例: 台北市信義區..."
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">地點連結 (Google Maps)</label>
        <input
          type="url"
          value={settings.pickupLocationUrl || ''}
          onChange={(e) => onChange({ ...settings, pickupLocationUrl: e.target.value })}
          placeholder="https://maps.google.com/..."
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">取件備註</label>
        <textarea
          value={settings.pickupNote || ''}
          onChange={(e) => onChange({ ...settings, pickupNote: e.target.value })}
          placeholder="例: 請於營業時間內取件"
          rows={3}
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary"
        />
      </div>

      {/* Preview */}
      {(settings.pickupLocation || settings.pickupNote) && (
        <div className="p-3 bg-gray-50 rounded-lg">
          <p className="text-xs text-gray-500 mb-2">預覽</p>
          <div className="p-3 bg-white rounded border border-gray-200">
            {settings.pickupLocation && (
              <div className="flex items-start gap-2 mb-2">
                <IconMapPin size={16} className="text-muted mt-0.5 shrink-0" />
                <div>
                  <p className="text-sm font-medium">{settings.pickupLocation}</p>
                  {settings.pickupLocationUrl && (
                    <a
                      href={settings.pickupLocationUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs text-primary hover:underline"
                    >
                      查看地圖
                    </a>
                  )}
                </div>
              </div>
            )}
            {settings.pickupNote && (
              <p className="text-xs text-gray-600 mt-2">{settings.pickupNote}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
